import { Box } from "@mui/material"
import React from "react"
import { ReportFormDrawerExportFiltersSection as CommonExportFiltersSection } from "Pages/ReportsAlerts/Reports/Common/Page/Drawer/Sections"
import SheetsField from "Pages/ReportsAlerts/Reports/OneWays/Page/Drawer/Sections/Sheets"

// The Common section plus the workbook sheets, kept out of the Show selector because they are required
export default function ReportFormDrawerExportFiltersSection() {
	return <CommonExportFiltersSection>
		<Box sx={{ gridColumn: '1 / -1' }} data-tour-id="tour-sheets">
			<SheetsField/>
		</Box>
	</CommonExportFiltersSection>
}
